import * as React from 'react';
import {connect} from "react-redux";

import {
  loadFrom,
  getAppointed,
  onRespondRequest,
  onWrittenReply,
  onAcceptRequest
} from "../../actions";

import { notify } from '../../modules/metajson-sub/src/libs/helpers/Utils';
import {IHandlers} from "../../services/ApiClient";
import {STATUS, STATUS_NAMES} from "../../types/enums";

import AppointmentRequestDialog from "../Dialogs/AppointmentRequestDialog";
import {RejectRequestDialog} from "../Dialogs/RejectRequest";
import {RespondRequest} from "../Dialogs/RespondRequest";
import {WrittenReplyDialog} from "../Dialogs/WrittenReplyDialog";
import SpecialistActions from "./SpecialistActions";
import MentorActions from "./MentorActions";

interface ActionsProps {
  schema: any;
  extRules: any;
  mode:string;
  progress: number;
  form_type: string;
  userRole: string;
  process_id: number;
  isVisible: boolean;
  status: number;
  readonly?: boolean;
  isPdf: boolean;
  user?: any;
  onSend: () => void;
  onPDF: () => void;
  onDraft: () => void;
  onDocument: (...args: any) => void;
  onRevoke: (comment?: boolean, personal?: boolean, title?: string) => void;
  onReturn: () => void;
  onDelete: () => void;
  onCopy: (lastComment?: string) => void;
  onLastComment: (lastComment?: string, lastCommentColor?: string) => void;
  onAddition: () => void;

  history?: Array<Record<string, any>>

  loadFrom: (form_type: string, process_id: number) => void
  onWrittenReply: (resolved: boolean, handlers: IHandlers) => void
  onRespondRequest: (message: string, handlers: IHandlers) => void
  onAcceptRequest: (accept: boolean, comment: string | null, handlers: IHandlers) => void
  getAppointed: (process_id: number) => void
  getHistory?: (process_id) => void
  appointedStatus: 'appointed' | 'confirmed' | 'refused'
}

interface ActionState {
  send: string;
  revoke: string;
  comment: any;
  visible: string[];
  lastComment?: string;
  lastCommentColor?: string;
  showOnLoad?: boolean;
  revokeColor?: string;
  initialModal: boolean;
  writtenReply?: string
  question?: string
  respondRequest?: string
  dialogs: Record<string, boolean>
}

const dialogs = {
  writtenReply: false,
  appointmentRequest: false,
  rejectRequest: false,
  respondRequest: false
}

class Actions extends React.Component<ActionsProps, ActionState> {
  componentWillMount() {
    const {status, getAppointed, process_id} = this.props;

    this.setState({
      dialogs: {...dialogs},
      ...this.props.extRules?.ActionsDefaultState,
      initialModal: this.props.userRole === 'user' && this.props.status === 0
    })

    getAppointed(process_id)

    if (STATUS[status] === 'WrittenReply') {
      this.onVisibleDialogs('writtenReply')()
    }
  }

  componentDidUpdate(prevProps: Readonly<ActionsProps>, prevState: Readonly<ActionState>) {
    if (prevProps.appointedStatus !== this.props.appointedStatus) {
      return true
    }
  }

  onVisibleDialogs = (name: string) => () => {
    this.setState((prevState) => ({
      dialogs: {
        ...prevState.dialogs,
        [name]: true
      }
    }))
  }

  onHideDialogs = (name: string) => () => {
    this.setState((prevState) => ({
      dialogs: {
        ...prevState.dialogs,
        [name]: false
      }
    }))
  }

  onHideAllDialogs = () => {
    this.setState({
      dialogs: {...dialogs}
    })
  }

  errorHandlerAfterDialogs = (error, response) => {
    this.onHideAllDialogs()

    if (response) {
      const resp = JSON.parse(response)
      notify(resp?.message ?? 'Действие временно недоступно',false)
      return
    }
    notify('Действие временно недоступно', false)
  }

  onAppointmentRequest = (name: string) => () => {
    this.onSubmitAcceptRequest(true, null, this.onVisibleDialogs(name))
  }

  onSubmitAcceptRequest = (accept: boolean, comment: string | null = null, callback?: () => void) => {
    const {onAcceptRequest, getAppointed, process_id} = this.props

    onAcceptRequest(accept, comment, {
      success: () => {

        if (typeof callback === 'function') {
          callback()
        }

        if (!accept) {
          this.onHideAllDialogs();
          notify(
              'Запрос отправлен',
              false,
              'Назначение'
          )
        }

        getAppointed(process_id)

      },
      error: this.errorHandlerAfterDialogs
    })
  }

  onSubmitRespondRequest = (message: string) => {
    const {onRespondRequest, loadFrom, form_type, process_id} = this.props

    onRespondRequest(message, {
      success: () => {
        this.onHideAllDialogs()
        notify('Ваш ответ отправлен', () => loadFrom(form_type, process_id),'Ответ')
      },
      error: this.errorHandlerAfterDialogs,
    })
  }

  onSubmitWrittenReply = (resolved: boolean) => {
    const {onWrittenReply, loadFrom, form_type, process_id} = this.props;

    onWrittenReply(resolved, {
      success: () => {
        this.onHideAllDialogs();
        notify('Запрос отправлен', () => loadFrom(form_type, process_id),'Письменный ответ')
      },
      error: this.errorHandlerAfterDialogs
    })
  }

  render() {
    const {mode, user, status, readonly, onDocument, history, appointedStatus} = this.props;
    const {question, lastCommentColor, writtenReply} = this.state;

    const isWrittenReply = STATUS[status] === 'WrittenReply'
    const isQuestion = STATUS[status] === 'Question'
    const isDraft = STATUS[status] === 'Draft'

    return (
      <>
        <div className="reportbox-actions">
          <div className="note">
            {mode === 'suspended' && <span style={{color: 'red'}}>Приём заявок временно приостановлен</span> }
            {mode === 'working' && <span>Данные заявки сохраняются автоматически</span> }
          </div>
          {user.isAuth && (

            <div className="btn-content">
              <button className="btn btn-backbutton btn-sm pull-right" onClick={this.props.onReturn}>
                Назад к списку заявок
              </button>

              {isWrittenReply && (
                <button
                  className="btn btn-warning btn-sm pull-right"
                  onClick={this.onVisibleDialogs('writtenReply')}
                >
                  {writtenReply}
                </button>
               )}

              {isQuestion && (
                <button
                  className="btn btn-sm pull-right btn-primary"
                  onClick={this.props.onLastComment.bind(this, STATUS_NAMES['Question'], lastCommentColor)}
                  style={lastCommentColor ? { backgroundColor: lastCommentColor, borderColor: lastCommentColor } : {}}
                >
                  {question}
                </button>
              )}

              {user?.is_specialist && (
                <SpecialistActions
                  status={status}
                  appointedStatus={appointedStatus}
                  onVisibleDialogs={this.onVisibleDialogs}
                  onAppointmentRequest={this.onAppointmentRequest}
                />
              )}

              {user?.is_mentor && (
                <MentorActions
                  status={status}
                  appointedStatus={appointedStatus}
                  onVisibleDialogs={this.onVisibleDialogs}
                  onAppointmentRequest={this.onAppointmentRequest}
                />
              )}

              {mode === 'working' && ((isDraft || isQuestion) && !readonly) && (
                <button
                  className="btn btn-success btn-sm pull-right"
                  onClick={() => {
                    onDocument({
                      callback: () => {
                        window.history.back();
                      },
                      notifyMessage: "Ваша заявка отправлена"
                    });
                  }}
                >
                  Отправить
                </button>
              )}

            </div>
          )}
        </div>

        <WrittenReplyDialog
          data={{history, status}}
          onSubmitReply={this.onSubmitWrittenReply}
          visible={this.state.dialogs.writtenReply}
          onHide={this.onHideAllDialogs}
        />
        <AppointmentRequestDialog
            visible={this.state.dialogs.appointmentRequest}
            onHide={this.onHideDialogs('appointmentRequest')}
        />
        <RejectRequestDialog
            visible={this.state.dialogs.rejectRequest}
            onHide={this.onHideDialogs('rejectRequest')}
            onSubmit={this.onSubmitAcceptRequest}
        />
        <RespondRequest
            visible={this.state.dialogs.respondRequest}
            onHide={this.onHideDialogs('respondRequest')}
            onSubmit={this.onSubmitRespondRequest}
        />
      </>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadFrom: (form_type: string, process_id: number) => dispatch(loadFrom(form_type, process_id)),
  getAppointed: (process_id: number) => dispatch(getAppointed(process_id)),
  onWrittenReply: (resolved: boolean, handlers: IHandlers) => dispatch(onWrittenReply(resolved, handlers)),
  onRespondRequest: (message: string, handlers: IHandlers) => dispatch(onRespondRequest(message, handlers)),
  onAcceptRequest: (accept: boolean, comment: null | string, handlers: IHandlers) => dispatch(onAcceptRequest(accept, comment, handlers))
})

const mapStateToProps = (state) => ({
  appointedStatus: state.forms.appointedStatus
})

export default connect(mapStateToProps, mapDispatchToProps)(Actions);

